import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "flex md6" }
const _hoisted_3 = { class: "flex md6" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "flex md6" }
const _hoisted_6 = { class: "mdo-select" }
const _hoisted_7 = { for: "discountType" }
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "flex md6" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "flex md3" }
const _hoisted_12 = { class: "flex md6" }
const _hoisted_13 = { class: "flex md3" }
const _hoisted_14 = { class: "flex md6" }

import {
  VoucherCreateInput,
  VoucherResponse,
  VoucherUpdateInput,
  ResultTestEnum,
  VoucherDiscountTypeEnum,
  OutsideBook
} from "@/codes/gen/types";
import { ReactiveData } from "@/codes/types/MDOTypes";
import { onMounted, reactive, ref } from "vue";
import { ROUTE_NAMES } from "@/codes/util/constants";
import { useI18n } from "vue-i18n";
import { VoucherService } from "@/codes/services/VoucherService";
import router from "@/router";
import { useRoute } from "vue-router";
import { useForm } from "vee-validate";
import { Confirm } from "@/codes/util/swalUtil";
import {OutsideBookService} from "@/codes/services/OutsideBookService";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const voucher = reactive<ReactiveData<VoucherCreateInput>>({ data: {} as VoucherCreateInput });
const today = new Date();
const tomorrow = new Date();
tomorrow.setDate(today.getDate() + 1);
const expiredAt = ref(tomorrow);

const i18n = useI18n();

const allowedResults = reactive({ data: [] as any });
const outsideBooks = reactive<ReactiveData<OutsideBook[]>>({ data: [] as OutsideBook[] });

for (const a of Object.values(ResultTestEnum)) {
  const t = i18n.t(`enums.${a}`);
  allowedResults.data.push({ text: t, value: a });
}

const discountTypes = reactive({ data: [] as any });
for (const a of Object.values(VoucherDiscountTypeEnum)) {
  const t = i18n.t(`enums.${a}`);
  discountTypes.data.push({ text: t, value: a });
}

const isEdit = ref(false);
let idVoucherEdit = '';

const form = useForm();
const formMeta = reactive(form.meta);

const loadVoucher = async function(id: string) {
  const service = new VoucherService();
  const result = await service.get(id);

  if (result) {
    const vc: VoucherCreateInput = {
      name: result.name,
      description: result.description,
      discountType: result.discountType,
      discountValue: result.discountValue,
      allowedResults: result.allowedResults,
      maxCodes: result.maxCodes,
      expiredAt: result.expiredAt,
      outsideBooks: result.outsideBooks
    }

    if (result.expiredAt && result.expiredAt.iso) {
      expiredAt.value = new Date(result.expiredAt.iso?.toString());
    }
    voucher.data = vc;
    form.setValues(vc);
  }
}

const loadOutsideBooks = async function() {
  outsideBooks.data = [];
  const service = new OutsideBookService();
  const usersEdge = await service.getAll({});
  if (usersEdge) {
    outsideBooks.data = usersEdge.edges;
  }
}

onMounted(() => {
  const route = useRoute();
  loadOutsideBooks();

  if (route && route.name === ROUTE_NAMES.editVoucher) {
    idVoucherEdit = route.params.id as string;
    loadVoucher(idVoucherEdit);
    isEdit.value = true;
  }
})

const save = async function() {
  const validate = await form.validate() as any;
  if (validate.valid) {
    const service = new VoucherService();
    const funcConcluir = (result: VoucherResponse | null | undefined) => {
      if (result && result.data.id) {
        idVoucherEdit = '';
        router.push({ name: ROUTE_NAMES.vouchers });
      }
    }
    voucher.data.maxCodes = parseInt(voucher.data.maxCodes.toString());
    voucher.data.discountValue = parseFloat(voucher.data.discountValue.toString());
    voucher.data.expiredAt = expiredAt;
    if (isEdit.value) {
      const getoutsideBooksIds = ()=>{
        const data = voucher.data.outsideBooks?.map(book => {
          if( book instanceof Object && book.id){
            return book.id
          }
          if(typeof book === "string"){
            return book;
          }
        })
        return data;
      }

      const voucherUpdate: VoucherUpdateInput = {
        name: voucher.data.name,
        description: voucher.data.description,
        discountType: voucher.data.discountType,
        discountValue: voucher.data.discountValue,
        allowedResults: voucher.data.allowedResults,
        outsideBooks: getoutsideBooksIds(),
        expiredAt: voucher.data.expiredAt,
        maxCodes: voucher.data.maxCodes
      };



      const result = await service.update(idVoucherEdit, voucherUpdate);
      funcConcluir(result);
    } else {
      const result = await service.create(voucher.data);
      funcConcluir(result);
    }
  }
}

function cancel() {
  if (form.meta.value.dirty) {
    Confirm.fire({
      title: i18n.t('form.confirmCancelTitle'),
      text: i18n.t('form.confirmCancelText')
    })
    .then((result) => {
      if (result.isConfirmed) {
        router.push({ name: ROUTE_NAMES.vouchers });
      }
    });
  } else {
    router.push({ name: ROUTE_NAMES.vouchers });
  }
}


return (_ctx: any,_cache: any) => {
  const _component_va_input = _resolveComponent("va-input")!
  const _component_VField = _resolveComponent("VField")!
  const _component_va_select = _resolveComponent("va-select")!
  const _component_va_date_input = _resolveComponent("va-date-input")!
  const _component_base_form = _resolveComponent("base-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_base_form, {
      "form-meta": _unref(formMeta),
      onSave: save,
      onCancel: cancel
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_VField, {
              name: "name",
              rules: "required|min:6"
            }, {
              default: _withCtx(({ field, errors: nameErrors }) => [
                _createVNode(_component_va_input, _mergeProps(field, {
                  modelValue: _unref(voucher).data.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_unref(voucher).data.name = $event)),
                  class: "mb-4",
                  label: _ctx.$t('register.name'),
                  error: nameErrors && nameErrors.length > 0,
                  "error-messages": nameErrors
                }), null, 16, ["modelValue", "label", "error", "error-messages"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_VField, {
              name: "description",
              rules: "required|min:6"
            }, {
              default: _withCtx(({ field, errors: descriptionError }) => [
                _createVNode(_component_va_input, _mergeProps(field, {
                  modelValue: _unref(voucher).data.description,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_unref(voucher).data.description = $event)),
                  class: "mb-4",
                  label: _ctx.$t('register.description'),
                  error: descriptionError && descriptionError.length > 0,
                  "error-messages": descriptionError
                }), null, 16, ["modelValue", "label", "error", "error-messages"])
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('voucher.discountType')), 1),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_unref(voucher).data.discountType = $event)),
                name: "discountType"
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(discountTypes).data, (op) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: op.value,
                    value: op.value
                  }, _toDisplayString(op.text), 9, _hoisted_8))
                }), 128))
              ], 512), [
                [_vModelSelect, _unref(voucher).data.discountType]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_VField, { name: "discountValue" }, {
              default: _withCtx(({ field, errors: discountValueError }) => [
                _createVNode(_component_va_input, _mergeProps(field, {
                  modelValue: _unref(voucher).data.discountValue,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_unref(voucher).data.discountValue = $event)),
                  type: "number",
                  class: "mb-4",
                  label: _ctx.$t('voucher.discountValue'),
                  error: discountValueError && discountValueError.length > 0,
                  "error-messages": discountValueError
                }), null, 16, ["modelValue", "label", "error", "error-messages"])
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_VField, { name: "maxCodes" }, {
              default: _withCtx(({ field, errors: maxCodesError }) => [
                _createVNode(_component_va_input, _mergeProps(field, {
                  modelValue: _unref(voucher).data.maxCodes,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_unref(voucher).data.maxCodes = $event)),
                  class: "mb-4",
                  label: _ctx.$t('voucher.maxCodes'),
                  error: maxCodesError && maxCodesError.length > 0,
                  "error-messages": maxCodesError
                }), null, 16, ["modelValue", "label", "error", "error-messages"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_VField, {
              name: "allowedResults",
              rules: "required"
            }, {
              default: _withCtx(({ field, errors: allowedResultsError }) => [
                _createVNode(_component_va_select, _mergeProps(field, {
                  modelValue: _unref(voucher).data.allowedResults,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_unref(voucher).data.allowedResults = $event)),
                  class: "mb-4",
                  label: _ctx.$t('voucher.allowedResults'),
                  options: _unref(allowedResults).data,
                  outline: "",
                  multiple: "",
                  "text-by": (option) => option.text,
                  "value-by": (option) => option.value,
                  error: allowedResultsError && allowedResultsError.length > 0,
                  "error-messages": allowedResultsError
                }), {
                  content: _withCtx(({ value }) => [
                    _createTextVNode(_toDisplayString(value ? value.map((v) => _ctx.$t(`enums.${v}`)).join(', ') : ''), 1)
                  ]),
                  _: 2
                }, 1040, ["modelValue", "label", "options", "text-by", "value-by", "error", "error-messages"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_VField, { name: "expiredAt" }, {
              default: _withCtx(({ field, errors: expiredAtError }) => [
                _createVNode(_component_va_date_input, _mergeProps(field, {
                  modelValue: expiredAt.value,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (expiredAt.value = $event)),
                  class: "mb-4",
                  label: _ctx.$t('voucher.expiredAt'),
                  error: expiredAtError && expiredAtError.length > 0,
                  "error-messages": expiredAtError
                }), null, 16, ["modelValue", "label", "error", "error-messages"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_VField, { name: "outsideBooks" }, {
              default: _withCtx(({ field }) => [
                _createVNode(_component_va_select, _mergeProps(field, {
                  modelValue: _unref(voucher).data.outsideBooks,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_unref(voucher).data.outsideBooks = $event)),
                  class: "mb-4",
                  label: "Qr Codes (opcional)",
                  options: _unref(outsideBooks).data,
                  outline: "",
                  multiple: "",
                  "text-by": "name",
                  "value-by": "id",
                  placeholder: "Disponível para todos os Qr Codes.",
                  messages: ['Você pode selecionar quantos Qr Codes quiser.', 'Caso não selecione nenhum Qr Code este voucher estará disponível para TODOS os Qr Codes.']
                }), null, 16, ["modelValue", "options", "messages"])
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["form-meta"])
  ]))
}
}

})